module.exports = __webpack_public_path__ + "img/green-coral-01.82fc1079.png";